<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('grant_registration.archived_application') }}</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
          <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
            <b-row>
              <b-col xl="6" lg="6" sm="12">
                  <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                      <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="fiscal_year_id"
                          slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                          {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                          plain
                          v-model="search.fiscal_year_id"
                          :options="fiscalYearList"
                          id="fiscal_year_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                          {{ errors[0] }}
                      </div>
                      </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-form-group
                class="row"
                label-cols-md="12"
                label-cols-lg="3"
                  :label="$t('grant_budget_management.organization')"
                  label-for="org_id"
                >
                  <b-form-select
                    plain
                    v-model="search.org_id"
                    :options="orgList"
                    id="org_id"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-form-group
                class="row"
                label-cols-md="12"
                label-cols-lg="3"
                :label="$t('grant_config.service_type')"
                label-for="service_type_list"
                >
                  <b-form-select
                    plain
                    v-model="search.service_type_id"
                    :options="serviceTypeList"
                    id="service_type_list"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                  class="row"
                  label-cols-md="12"
                label-cols-lg="3"
                  :label="$t('grant_config.service_name')"
                  label-for="service_list"
                  >
                    <b-form-select
                      plain
                      v-model="search.service_list_id"
                      :options="serviceList"
                      id="service_list"
                      >
                      <template v-slot:first>
                      <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col class="text-right">
                <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
    <!-- /Search Form -->

    <!-- Table/List -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('grant_registration.archived_application_list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                   <template v-slot:cell(action)="data">
                      <a href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-2 @click="view(data.item)"><i class="ri-eye-fill m-0"></i></a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- Table/List -->
    <b-modal id="modal-2" size="xl" :title="ViewTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import Details from './Details'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { applicationListApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import moment from 'moment'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Details, ValidationObserver, ValidationProvider
  },
  data () {
    return {
      editItemId: 0,
      search: {
        service_type_id: 0,
        service_list_id: 0,
        org_id: 0,
        fiscal_year_id: 0,
        fis_start_date: '',
        fis_end_date: '',
        is_archive: 1
      },
      url: grantAllowanceServiceBaseUrl,
      serviceList: [],
      rows: []
    }
  },
  computed: {
    fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList () {
        return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
     serviceTypeList: function () {
        const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    ViewTitle () {
       return this.$t('grant_registration.archived_application_list') + ' ' + this.$t('globalTrans.details')
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('globalTrans.organization'), class: 'text-center' },
          { label: this.$t('grant_config.service_type'), class: 'text-center' },
          { label: this.$t('grant_config.service_name'), class: 'text-center' },
          { label: this.$t('grant_registration.application_type'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' },
          { label: this.$t('grant_registration.created'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'org_name_bn' },
          { key: 'service_type_bn' },
          { key: 'service_name_bn' },
          { key: 'application_type_bn' },
          { key: 'action' },
          { key: 'created_time' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'org_name' },
          { key: 'service_type' },
          { key: 'service_name' },
          { key: 'application_type_en' },
          { key: 'action' },
          { key: 'created_time' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    'search.service_type_id': function (newVal) {
      this.serviceList = this.getServiceList(newVal)
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
        if (newVal !== 0) {
          const fiscalYearId = parseInt(newVal)
          const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
          this.search.fiscal_year_id = fiscalYear.value
          this.search.fis_start_date = fiscalYear.start_date
          this.search.fis_end_date = fiscalYear.end_date
       } else {
          this.search.fiscal_year_id = 0
          this.search.fis_start_date = ''
          this.search.fis_end_date = ''
       }
    },
    '$i18n.locale': function (newValue) {
        this.serviceList = this.getServiceList()
    }
  },
   created () {
        this.loadData()
    },
  mounted () {
  },
  methods: {
    searchData () {
      this.loadData()
    },
    edit (item) {
      this.editItemId = item.id
    },
    view (item) {
      this.editItemId = item.id
    },
    remove (item) {
      this.changeStatus(grantAllowanceServiceBaseUrl, item)
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(grantAllowanceServiceBaseUrl, applicationListApi, params).then(response => {
            if (response.success) {
                this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                this.paginationData(response.data)
            }
            this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
     getRelationalData (data) {
          const listData = data.map(item => {
            const tmpOrg = this.$store.state.orgList.find(org => org.status === 0 && org.value === item.org_id)
            const tmpServiceType = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList.find(service => service.value === item.service_type_id)
            const tmpServiceName = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.find(service => service.status === 0 && service.value === item.service_id)
            const tmpFiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscalYear => fiscalYear.status === 0 && fiscalYear.value === item.fiscal_year_id)
            const tmpApplicationType = this.$store.state.commonObj.applicationTypeList.find(type => type.value === parseInt(item.application_type))
            const tmpCreatedTime = moment(item.updated_at).startOf('minute').fromNow()

            const newData = {
                org_name: tmpOrg !== undefined ? tmpOrg.text_en : '',
                org_name_bn: tmpOrg !== undefined ? tmpOrg.text_bn : '',
                service_type: tmpServiceType !== undefined ? tmpServiceType.text_en : '',
                service_type_bn: tmpServiceType !== undefined ? tmpServiceType.text_bn : '',
                service_name: tmpServiceName !== undefined ? tmpServiceName.text_en : '',
                service_name_bn: tmpServiceName !== undefined ? tmpServiceName.text_bn : '',
                fiscal_name: tmpFiscalYear !== undefined ? tmpFiscalYear.text_en : '',
                fiscal_name_bn: tmpFiscalYear !== undefined ? tmpFiscalYear.text_bn : '',
                application_type_en: tmpApplicationType !== undefined ? tmpApplicationType.text_en : '',
                application_type_bn: tmpApplicationType !== undefined ? tmpApplicationType.text_bn : '',
                created_time: tmpCreatedTime !== undefined ? tmpCreatedTime : ''
            }
            return Object.assign({}, item, newData)
          })
          return listData
        },
    getServiceList () {
      const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === this.search.service_type_id && item.has_public_form === 1)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    }
  }
}
</script>
